function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.82 21.66L18.48 19l1.16 1.18L15.82 24 12 20.18 13.16 19l2.66 2.66zm0-10.32L13.16 14 12 12.82 15.82 9l3.82 3.82L18.48 14l-2.66-2.66z",
  fill: "#4A4A4A",
  fillRule: "evenodd"
})));